import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import VirtualizedTable from "../components/VirtualizeTable";
import { MRT_ColumnDef } from "material-react-table";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { formatPrice } from "../helpers/format";
import ProductsDelete from "./ProductsDelete";

const ProductsTableComponent = ({
  data,
  refetch,
}: {
  data: Array<{
    id: string;
    name: string;
    description?: string;
    price?: number;
    type?: string;
    status: string;
    createdAt: string | Date;
  }>;
  refetch: () => void;
}) => {
  const navigate = useNavigate();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [id, setId] = useState("");

  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(() => {
    return [
      {
        id: "img",
        header: "Foto",
        size: 50,
        Cell: ({ row }: any) =>
          row?.original?.img ? (
            <img
              src={row?.original?.img}
              style={{
                borderRadius: "10px",
                maxWidth: "40px",
                maxHeight: "40px",
              }}
            />
          ) : (
            "--"
          ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "name",
        header: "Nome",
      },
      {
        accessorKey: "sku",
        header: "SKU",
        Cell: ({ cell }: any) => cell.getValue() || "--",
        exportValue: (row: any) => row.sku || "", // ou: "amount"
      },
      {
        accessorKey: "qty",
        header: "Estoque",
        size: 100,
      },
      {
        accessorKey: "price",
        header: "Preço",
        Cell: ({ cell }: any) => formatPrice(cell.getValue()),
        size: 100,
      },
      {
        id: "edit",
        header: "Editar",
        size: 50,
        Cell: ({ row }: any) => (
          <IconEdit
            onClick={() => navigate(`/products/${row.original.id}`)}
            style={{ cursor: "pointer", color: "#FFF" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
      {
        id: "delete",
        header: "Excluir",
        size: 50,
        Cell: ({ row }: any) => (
          <IconTrash
            onClick={() => {
              setId(row.original.id);
              setDeleteAlert(true);
            }}
            style={{ cursor: "pointer", color: "#d32f2f" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ] as any;
  }, [data]);

  return (
    <>
      <VirtualizedTable
        data={data}
        enableExportCSV
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />

      <ProductsDelete
        open={deleteAlert}
        onClose={() => setDeleteAlert(false)}
        id={id}
        onAction={refetch}
      />
    </>
  );
};

export default ProductsTableComponent;
